import { useState } from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { VariantMatrix } from './VariantMatrix'
import { SharedListsTab } from './SharedListsTab'

/**
 * Menu → Variants (F-MOD-N12).
 *
 * Two views. The matrix is where a whole menu gets set up or changed at
 * once: items down, shared lists across. Shared lists is the library, for
 * editing a list many items ask. Setting up ONE item happens on the item.
 */
type View = 'matrix' | 'lists'

export function AdminVariantsTab() {
  const [view, setView] = useState<View>('matrix')

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="max-w-2xl space-y-1">
            <h3 className="font-semibold">Variants</h3>
            <p className="text-sm text-muted-foreground">
              Sizes and the questions the till asks when an item is tapped. Set up one item on the item itself; use this page for the whole menu at once.
            </p>
          </div>
          <div className="inline-flex overflow-hidden rounded-lg border text-sm" role="tablist" aria-label="Variants view">
            {([['matrix', 'Matrix'], ['lists', 'Shared lists']] as Array<[View, string]>).map(([v, label]) => (
              <button
                key={v}
                type="button"
                role="tab"
                aria-selected={view === v}
                onClick={() => setView(v)}
                className={cn(
                  'px-3 py-1.5 first:border-r',
                  view === v ? 'bg-primary/10 font-medium text-primary' : 'text-muted-foreground hover:bg-muted',
                )}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        {view === 'matrix' ? <VariantMatrix /> : <SharedListsTab />}
      </CardContent>
    </Card>
  )
}
